// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-dropdown {
    border: 1px solid whitesmoke;
    height: 1.5em;
}

:host ::ng-deep .p-dropdown {
    border-color: whitesmoke;
}

:host ::ng-deep .p-dropdown:hover,
:focus {
    border-color: whitesmoke;
}

:host ::ng-deep .p-dropdown .p-dropdown-trigger {
    background-color: rgb(33, 37, 41);
    width: 1.5em;
}

:host ::ng-deep .p-dropdown-items-wrapper {
    border-radius: 3px;
}

:host ::ng-deep .p-dropdown .p-dropdown-label {
    width: 13em;
    text-align: center;
    padding: 0;
    background: rgb(33, 37, 41);
    font-size: 12px;
    margin-right: 0.5px;
    font-family: "EYInterstate-light";
}

:host ::ng-deep .p-dropdown-panel .p-dropdown-items {
    padding: 0;
    border: thin black;
    background: rgb(33, 37, 41);
    color: #fff;
    width: 9.8em;
}

.display-flex {
    display: flex;
}

:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    line-height: 0.8em;
    font-size: 12px;
}

:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #212529;
    background-color: #ffe082 !important;
}

.lang-disabled {
    color: lightgray;
    cursor: not-allowed;
    opacity: 0.5;
}
.spacing {
  padding-right: 0.7rem !important;
}

:host ::ng-deep .p-menu > ul {
    padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-components/header/header.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;AACA;EACE,gCAAgC;AAClC;;AAEA;IACI,UAAU;AACd","sourcesContent":[":host ::ng-deep .p-dropdown {\r\n    border: 1px solid whitesmoke;\r\n    height: 1.5em;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown {\r\n    border-color: whitesmoke;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown:hover,\r\n:focus {\r\n    border-color: whitesmoke;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown .p-dropdown-trigger {\r\n    background-color: rgb(33, 37, 41);\r\n    width: 1.5em;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown-items-wrapper {\r\n    border-radius: 3px;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown .p-dropdown-label {\r\n    width: 13em;\r\n    text-align: center;\r\n    padding: 0;\r\n    background: rgb(33, 37, 41);\r\n    font-size: 12px;\r\n    margin-right: 0.5px;\r\n    font-family: \"EYInterstate-light\";\r\n}\r\n\r\n:host ::ng-deep .p-dropdown-panel .p-dropdown-items {\r\n    padding: 0;\r\n    border: thin black;\r\n    background: rgb(33, 37, 41);\r\n    color: #fff;\r\n    width: 9.8em;\r\n}\r\n\r\n.display-flex {\r\n    display: flex;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {\r\n    line-height: 0.8em;\r\n    font-size: 12px;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\r\n    color: #212529;\r\n    background-color: #ffe082 !important;\r\n}\r\n\r\n.lang-disabled {\r\n    color: lightgray;\r\n    cursor: not-allowed;\r\n    opacity: 0.5;\r\n}\r\n.spacing {\r\n  padding-right: 0.7rem !important;\r\n}\r\n\r\n:host ::ng-deep .p-menu > ul {\r\n    padding: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
